module.exports = __webpack_public_path__ + "static/media/full_4.12e73468.jpg";